import React, { useEffect } from "react";
import { Column, usePagination, useSortBy, useTable } from "react-table";
import { faSortDown } from "@fortawesome/pro-solid-svg-icons/faSortDown";
import { faSortUp } from "@fortawesome/pro-solid-svg-icons/faSortUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Paginator } from "./Paginator";
import { EMPTY_ARRAY, EMPTY_OBJECT } from "../../Components/misc";
import { LoadingIndicator } from "../../Components/LoadingIndicator";
import styles from "./ReportingTable.module.scss";

export interface ReportingTableProps {
    columns: Column<{}>[];
    data: Array<{}>;
    defaultSortBy?: { id: string; desc: boolean }[];
    loading?: boolean;
    resortSignal?: {};
    columnClassNames?: string[];
    rowClassNames?: string[];
    className?: string;
    headerJSXElement?: JSX.Element;

    emptyMessage?: string;
    pageSize?: number;
}

export const ReportingTable: React.FC<ReportingTableProps> = ({
    columns,
    data,
    defaultSortBy,
    resortSignal = EMPTY_OBJECT,
    loading = false,
    emptyMessage = "No data",
    columnClassNames = EMPTY_ARRAY,
    rowClassNames = EMPTY_ARRAY,
    pageSize = 10,
    className = "",
    headerJSXElement
}) => {
    const sortBy = defaultSortBy ?? [];

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        pageCount,
        state: { pageIndex },
        prepareRow,
        gotoPage,
        setSortBy
    } = useTable(
        //    pageSize: 3,
        //    pageIndex: 0
        // sortBy,
        //}
        // },
        //initialState: {
        // autoResetPage: true
        //    data
        //    columns,
        // {
        //>

        //}
        // autoResetPage: boolean;
        // data: Array<{}>;
        // columns: Column<{}>[];
        //{
        //<
        {
            columns,
            data,
            initialState: {
                pageSize,
                pageIndex: 0,
                sortBy
            }
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        if (!loading) {
            gotoPage(0);
            setSortBy(sortBy);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, gotoPage, setSortBy]);

    useEffect(() => {
        setSortBy(sortBy);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resortSignal, setSortBy]);

    const columnWidth = {
        width: `${Math.ceil(100 / columns.length)}%`
    };
    return (
        <>
            <div className={`${className} custom-scrollbar ${styles["table"]} `}>
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, index) => {
                                    const {
                                        style,
                                        className: columnClassName,
                                        ...columnProps
                                    } = column.getHeaderProps(column.getSortByToggleProps());
                                    return (
                                        <th
                                            {...columnProps}
                                            style={{
                                                // ...columnWidth,
                                                width: index === 0 ? "33%" : index === 1 ? "25%" : columnWidth.width,
                                                ...style
                                            }}
                                            className={`
                                        ${data.length > 1 && column.canSort ? styles["sortable"] : ""}
                                        ${data.length <= 1 && column.canSort ? styles["sortable-disabled"] : ""}
                                        ${columnClassNames?.[index] ?? ""}
                                        ${columnClassName ?? ""}
                                    `}
                                            title={`${
                                                column.canSort
                                                    ? "Toggle the column to sort the table by the column values"
                                                    : ""
                                            }`}
                                        >
                                            <span>{column.render("Header")}</span>

                                            <span>
                                                {data.length > 1 &&
                                                    column.canSort &&
                                                    (column.isSorted ? (
                                                        column.isSortedDesc ? (
                                                            <span className={`fa-layers ml-2 ${styles["icon"]}`}>
                                                                <FontAwesomeIcon
                                                                    icon={faSortDown}
                                                                    className={` ml-0 ${styles["sort-down"]} ${styles["active"]}`}
                                                                />
                                                                <FontAwesomeIcon
                                                                    icon={faSortUp}
                                                                    className={`ml-0 ${styles["sort-up"]}`}
                                                                />
                                                            </span>
                                                        ) : (
                                                            <span className={`fa-layers ml-2 ${styles["icon"]}`}>
                                                                <FontAwesomeIcon
                                                                    icon={faSortDown}
                                                                    className={` ml-0 ${styles["sort-down"]}`}
                                                                />
                                                                <FontAwesomeIcon
                                                                    icon={faSortUp}
                                                                    className={` ml-0 ${styles["sort-up"]} ${styles["active"]}`}
                                                                />
                                                            </span>
                                                        )
                                                    ) : (
                                                        <span className={`fa-layers ml-2 ${styles["icon"]}`}>
                                                            <FontAwesomeIcon
                                                                icon={faSortDown}
                                                                className={` ml-0 ${styles["sort-down"]}`}
                                                            />
                                                            <FontAwesomeIcon
                                                                icon={faSortUp}
                                                                className={`ml-0 ${styles["sort-up"]}`}
                                                            />
                                                        </span>
                                                    ))}
                                            </span>
                                        </th>
                                    );
                                })}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                        {headerJSXElement && (
                            <tr>
                                <td colSpan={columns.length}>{headerJSXElement}</td>
                            </tr>
                        )}

                        {loading && (
                            <tr>
                                <td colSpan={columns.length}>
                                    {" "}
                                    <LoadingIndicator />
                                </td>
                            </tr>
                        )}

                        {!loading && (!data || data.length === 0) && (
                            <tr className={styles["no-data"]}>
                                <td colSpan={Math.max(columns.length, 15)}>{emptyMessage}</td>
                            </tr>
                        )}

                        {!loading &&
                            data &&
                            data.length !== 0 &&
                            (page ?? []).map((row, rowIndex) => {
                                prepareRow(row);

                                return (
                                    <tr
                                        className={`table-border ${row.canExpand ? styles["can-expand"] ?? "" : ""}`}
                                        key={rowIndex}
                                    >
                                        {(row.cells ?? []).map((cell, columnIndex) => {
                                            const { className, style, ...cellProps } = cell.getCellProps();
                                            return (
                                                <td
                                                    className={`${className ?? ""} ${
                                                        rowClassNames?.[columnIndex] ?? ""
                                                    }`}
                                                    style={{
                                                        ...columnWidth,
                                                        ...(style ?? {})
                                                    }}
                                                    {...cellProps}
                                                >
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            </div>
            <Paginator
                total={data?.length ?? 0}
                count={pageCount}
                index={pageIndex}
                onPageSelect={index => {
                    gotoPage(index);
                }}
            />
        </>
    );
};
